import * as React from 'react';
import { observer } from 'mobx-react';
import { configConsumer } from '@estee/elc-service';
import { GridItem } from '~domain/entities/GridItem';
import { gridItemType } from '~constants/ProductGrid';
import { ColumnRenderer } from '../column-renderer/ColumnRenderer';
import { classes } from '~utils/Classes';
import { PRODUCT_BRIEF_CLASS_NAMES } from '~constants/ProductBriefCollection';
import { IOrderConfigCollection } from '~interfaces/IOrderableComponents';
import { ProductBriefItem } from './ProductBriefItem';
import { IBreakpoints } from '../../interfaces/IBreakpoints';

interface IProductBriefViewContent {
    breakpoints?: IBreakpoints;
    config?: IProductBriefViewContentConfig;
    gridItems: GridItem[];
    isMobile?: boolean;
    isLoaded: boolean;
    areFiltersApplied?: boolean;
}

interface IProductBriefViewContentConfig {
    enableGridCarousel?: boolean;
    featuredProductOverrideImage?: string;
    componentElementsOrderConfig?: { [key: string]: IOrderConfigCollection };
}

@configConsumer([
    'enableGridCarousel',
    'featuredProductOverrideImage',
    'componentElementsOrderConfig'
])
@observer
export class ProductBriefViewContent extends React.Component<IProductBriefViewContent> {
    private shouldRenderItem = (item: GridItem) => {
        const { areFiltersApplied } = this.props;

        return (areFiltersApplied && item.itemType === gridItemType.product) || !areFiltersApplied;
    };

    public render() {
        const {
            config: { enableGridCarousel } = {},
            gridItems = [],
            isMobile,
            isLoaded,
            areFiltersApplied,
            breakpoints
        } = this.props;

        return gridItems.reduce((components: React.ReactElement[], item) => {
            const shouldRenderItem: boolean = this.shouldRenderItem(item);
            shouldRenderItem &&
                components.push(
                    <ColumnRenderer
                        key={`column-for-${item.itemId}`}
                        isCarousel={enableGridCarousel}
                        isMobile={!!isMobile}
                        columns={item.w}
                        rows={item.h}
                        className={classes(
                            `grid-item-${item.itemType}`,
                            PRODUCT_BRIEF_CLASS_NAMES.GRID_ITEM_CLASS_NAME
                        )}
                    >
                        <ProductBriefItem
                            breakpoints={breakpoints}
                            gridItem={item}
                            isMobile={isMobile}
                            isLoaded={isLoaded}
                            areFiltersApplied={areFiltersApplied}
                        />
                    </ColumnRenderer>
                );

            return components;
        }, []);
    }
}
